/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import './index.scss'
import FadeIn from 'react-fade-in';


import Deck from './ExperienceCard'

const Experience = () => {
  const aboutArray = ' Work Experience'.split('')

  const [letterClass, setLetterClass] = useState('text-animate');
  const [experience, setExperience] = useState(0);
  const explist = [
    {
      role: 'Full Stack Developer & Blockchain Engineer',
      developed: [
        '- Supervised development of REST - based services and took part in POCs.',
        '- Simultaneously created & maintained scheduled jobs in SQL Server for space maintenance and daily backups of system and user databases for 10 clients.',
        '- Increased company revenue by 30% within 2 months after developing and implementing business logic for over 20 features.',
        '- Disseminated information and education regarding cryptocurrency and blockchain technology, and shared unmatched knowledge on decentralized technologies.',
      ],
      period:"From March 2021 to January 2022 CodeBright",
      link: "https://codebrightly.com/"
    },
    {
      role: 'FrontEnd & Backend developer',
      developed: [
        '- Develop 10+ full-stack web applications to analyze and process data for different clients',
        '- Ensure applications security and ability to interact with multiple APIs and databases',
        '- Design and create a knowledge management platform on a knowledge graph, utilizing a range of technologies, including Node.js, Typescript, Dgraph, React, and Mobx',
        '- Develop and implement a standalone data extraction agent and main-application features for a financial product',
      ],
      period:"From November 2017 to April 2018",
      link: "https://www.keelinggroup.com/"
    },
    {
      role: 'Rust Developer',
      developed: [
        '- Played a key role in the development, improvement, and operation of web-based software',
        '- Gained hands-on expertise in Bootstrap, Foundation, Express and similar back-end Node.js as well as front-end presentation frameworks web application frameworks',
        '- Optimized the smart contract code and increased the efficiency by 15%, using the Library functionalities of the solidity',
        '- Designed and developed the smart contracts',
      ],
      period:"From May 2018 to February 2019",
      link: "https://toypoodlecoin.com/"
    },
    {
      role: 'Full Stack Engineer',
      developed: [
        '- Developed Solana-Web3 on React(TypeScript) based Front-End',
        '- Developed Governance Token with ERC20',
        '- Developed Solana-Rust for Vesting Schedule which is deployed onto mainnet',
        '- Review & Developed Smart Contract on Ubuntu and Windows WSL',
      ],
      period:"From March 2020 to March 2021",
      link: "https://www.dexlab.space/"
    },
  ]

  useEffect(() => {
    const timer = setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 2000)
    return () => clearTimeout(timer)
  }, [experience])
 

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={aboutArray}
              idx={15}
            />
          </h1>
         <FadeIn key={experience}>
            <p
              style={{fontSize:"22px", color: "yellow"}}>
              {explist[experience].role}
            </p>
            {explist[experience].developed.map((item, index) => (
              <p style={{fontSize:"15px", color: "white",margin:"5px"}} key={index}>
                {item}
              </p>
            ))}
            <p 
              style={{fontSize:"20px", color: "yellow"}}
            >
              {explist[experience].period}
            </p>
            
            <a
              href= {explist[experience].link}
              target="_blank"
              rel="noreferrer"
              style={{fontSize:"18px", color: "white"}}
            >👉 
              {explist[experience].link}
            </a>
         </FadeIn>
        </div>
        <div className="experience-card">
          <Deck setExperience={setExperience} />
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default Experience
